import { myIcons } from "@/utils/icons";
import { t } from "i18next";

interface DetailsPropsI {
    topic: string;
    date: string;
    persons: number;
    state: string;
}
export const Details = ({ topic, date, persons, state }: DetailsPropsI) => {
    return (
        <div style={{
            padding: '10px',
            backgroundColor: 'var(--color-bg-third)',
            borderRadius: '0px 0px 10px 10px',
            color: 'var(--color-text)',
            marginBottom: '30px'
        }} >
            <p style={{ fontWeight: 'bold' }} >{"DETAYLAR"}</p>
            <p style={{ color: '#9e9e9e', marginBottom: '5px' }} >{t('topic')}</p>
            <p>{topic}</p>
            <p style={{ color: '#9e9e9e', marginBottom: '5px', marginTop: '10px' }} >{t('date')}</p>
            <p>{date}</p>

            <div style={{ display: 'flex', gap: '50px', marginTop: '10px' }} >
                <div>
                    <p style={{ color: '#9e9e9e', marginBottom: '5px' }} >{t('persons')}:</p>
                    <div style={{ display: 'flex', border: '2px solid #9e9e9e', borderRadius: '5px', justifyContent: 'space-evenly' }} >
                        <img width={15} src={myIcons.interfaces.user} alt="" />
                        <div style={{ display: 'flex', height: 'auto', width: '1.5px', backgroundColor: '#9e9e9e' }} ></div>
                        <p>{persons}</p>
                    </div>
                </div>
                <div>
                    <p style={{ color: '#9e9e9e', marginBottom: '5px' }} >{t('state')}</p>
                    <p style={{ backgroundColor: '#4caf501a', color: '#4caf50', padding: '2px', borderRadius: '5px' }} >{state}</p>
                </div>
            </div>
        </div>
    );
}